module.exports = __webpack_public_path__ + "static/media/Bass-Drum-1.40f42a70.wav";